// Mobile Menu drawer
(() => {

  const selectors = {
    menuSubDrawer: '.td-header-menu-mobile--subdrawer',
    menuToggles: '.td-js-toggle-mobile-subdrawer',
    menuContent: '.td-megamenu-sm-content',
  }
  const mobileToggles = document.querySelectorAll(selectors.menuToggles);

  const toggleSubDrawer = (e, item) => {
    const mobileSubDrawer = document.querySelector(selectors.menuSubDrawer);
    const mobileMenus = document.querySelectorAll(selectors.menuContent);

    if (mobileSubDrawer === null && mobileMenus.length == 0) return
    if (mobileToggles.length == 0) return

    const mobileMenusArray = Array.from(mobileMenus);
    const menuToToggle = mobileMenusArray.find(menu => menu.dataset.subdrawer == item.dataset.toggles);

    if (mobileSubDrawer.ariaHidden === 'true') {
      mobileSubDrawer.ariaHidden = 'false'  
      menuToToggle.ariaExpanded = 'true'
    } else {
      mobileSubDrawer.ariaHidden = 'true'
      setTimeout(() => menuToToggle.ariaExpanded = 'false', 200)
    }
  }
  mobileToggles.forEach((item) => item.addEventListener('click', (e) => toggleSubDrawer(e, item)));

  // Product Images Slick caroussel init
  // Using Jquery because Theme uses Slick for sliders and is only accesible through Jquery
  const carouselContainers = $('.td-product-media--carousel');
  if (carouselContainers.length != 0) {
    const initSlick = () => {
      carouselContainers.slick({
        centerMode: true,
        draggable: true,
        variableWidth: true,
        infinite: true,
        dots: true,
        slidesToShow: 1,
        arrows: true,
        slidesToScroll: 1,
        centerPadding: '50px',
        lazyLoad: 'ondemand',
        dotsClass: 'td-slick-dots'
      })
    };
    initSlick();
  }

  // Collection-list Slick caroussel init
  // Using Jquery because Theme uses Slick for sliders and is only accesible through Jquery
  const collectionCarousel = $('.td-collection-carousel');
  const collectionCarouselWrapper = $('.td-collection-carousel-wrapper');
  const collectionCarouselSlides = $('.td-collection-carousel-slide');

  if(collectionCarousel !== null) {
    collectionCarouselWrapper.removeClass('destroy-swiper');

    const initCollectionCarousel = new Swiper('.td-collection-carousel', {
      direction: 'horizontal',
      variableWidth: true,
      watchSlidesProgress: true,
      allowSlideNext: true,
      allowSlidePrev: true,
      allowTouchMove: true,
      slidesPerView: "auto",
      slidesPerGroup: 4,
      spaceBetween: 8,
      mousewheel: {
        forceToAxis: true
      },
      controller: {
        inverse: true
      },
      pagination: {
        el: ".swiper-pagination",
        paginationClickable: true
      },
      breakpoints: {
        0: {
          freeModeSticky: true
        },
        500: {
          slidesToShow: 2.5,
          slidesPerGroup: 2
        },
        767: {
          slidesToShow: 3.5,
          slidesPerGroup: 3
        },
        992: {
          freeMode: true,
          freeModeMomentumRatio: 0.5,
          freeModeMomentumVelocityRatio: 0.5,
          freeModeSticky: true,
          centerInsufficientSlides: true,
          centeredSlidesBounds: true
        }
      }
    });
  };


  // TODO: Find a way to make this work on the theme editor
  // Currently when there's a change in this section the slider will break unless the user presses save on the editor to re-render JS
  // Ideally the slider would re-render itself to prevent breaking
  if (Shopify.designMode) {
    document.addEventListener("shopify:section:load", () => {
      carouselContainers.slick('unslick');
      initSlick();
    })
  }
})();

//Minicart
var Minicart = {
  updateQuantity: function updateQuantity(line, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        quantity: qty,
        line: line
      })
    }).then(function (response) {
      return response.json();
    }).then(function (data) {
      // fire javascript event on window
      window.dispatchEvent(new Event('cart-updated'));
    })["catch"](function (error) {
      console.error('Error:', error);
    });
  }
};
window.Minicart = Minicart;

window.addEventListener('cart-updated', (e) =>{
  fetch('/?view=cart')
  .then(response => response.text())
  .then(html => {
    document.querySelector('#minicart').innerHTML = html
  })
})

//Description accordion and header insertion
$('.product__details-row:first-of-type .heading').addClass('active');
$('.product__details-row:first-of-type .body').slideDown();
$(".product__details-row .heading").click(function(){
  if($(this).hasClass('active')) {
    $(this).siblings('.product__details-row .body').slideUp();
    $(this).removeClass('active');
  }
  else {
    $('.product__details-row .body').slideUp();
    $('.product__details-row .heading').removeClass('active');
    $(this).siblings('.product__details-row .body').slideToggle();
    $(this).toggleClass('active');
  }
});     

//Close mini-cart on overlay click
const cartOverlay = document.getElementById("cart-overlay");

if(cartOverlay !== null) {
  cartOverlay.addEventListener("click", function() {
    if (document.body.classList.contains("minicart-open")) {
      document.body.classList.remove("minicart-open");
    }
  });
}

const toggleMinicartBtn = document.getElementById("header__mobile-cart-icon");

toggleMinicartBtn.addEventListener("click", function() {
  const swiper = new Swiper('.td-cart__recommendations-carousel', {
    direction: 'horizontal',
    loop: true,
    centeredSlides: true,
    watchSlidesProgress: true,
    allowSlideNext: true,
    slidesPerView: 1.5,
    spaceBetween: 8,
    mousewheel: {
      forceToAxis: true
    },
    controller: {
      inverse: true
    },
    breakpoints: {
      0: {
        freeModeSticky: true
      },
      992: {
        freeMode: true,
        freeModeMomentumRatio: 0.5,
        freeModeMomentumVelocityRatio: 0.5,
        freeModeSticky: true,
        centerInsufficientSlides: true,
        centeredSlidesBounds: true
      }
    }
  });
});

//Hamburger open closes minicart
const hamburgerIcon = document.getElementsByClassName("hamburger__wrapper");
const miniCartIcon = document.getElementsByClassName("js--toggle-minicart");
const mobileMenu = document.getElementById('mobile-menu');

for ( var i = 0; i < hamburgerIcon.length; i++) {
  hamburgerIcon[i].addEventListener('click', function() {
    mobileMenu.classList.toggle('show-menu');
  });
};

for ( var i = 0; i < miniCartIcon.length; i++) {
  miniCartIcon[i].addEventListener('click', function() {
    mobileMenu.classList.remove('show-menu');
  });
};

// Collection Pagination - Go-to feature
(() => {
  const formEl = document.querySelector('.td-pagination__form');

  if(formEl != null) {
    formEl.addEventListener('submit', (e) => {
      e.preventDefault();
      const targetPage = formEl.querySelector('.td-pagination__form-input').value;
  
      const currentURL = window.location.href
      const url = new URL(currentURL);
      const search_params = url.searchParams;
  
      search_params.set('page', targetPage );
      url.search = search_params.toString();
      var new_url = url.toString();
      window.location = new_url
    })
  }
})();





